import styled from 'styled-components'

export const DisplayContainer = styled.div`
  display: flex;
  justify-content: center;

  h1 {
    font-size: 2.8rem;
  }
`;